// SPDX-License-Identifier: AGPL-3.0-or-later
import type {I18n, MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';
export interface TimeoutDurationOption {
	value: number;
	label: string;
}
interface TimeoutDurationOptionDescriptor {
	value: number;
	label: MessageDescriptor;
}
const ONE_MINUTE_SECONDS = 60;
const FIVE_MINUTES_SECONDS = 5 * ONE_MINUTE_SECONDS;
const TEN_MINUTES_SECONDS = 10 * ONE_MINUTE_SECONDS;
const ONE_HOUR_SECONDS = 60 * ONE_MINUTE_SECONDS;
const ONE_DAY_SECONDS = 24 * ONE_HOUR_SECONDS;
const ONE_WEEK_SECONDS = 7 * ONE_DAY_SECONDS;
const ONE_UNIT_LABEL = 1;
const TIMEOUT_DURATION_OPTIONS_DESCRIPTORS: ReadonlyArray<TimeoutDurationOptionDescriptor> = [
	{value: ONE_MINUTE_SECONDS, label: msg`${ONE_MINUTE_SECONDS} seconds`},
	{value: FIVE_MINUTES_SECONDS, label: msg`${FIVE_MINUTES_SECONDS / ONE_MINUTE_SECONDS} minutes`},
	{value: TEN_MINUTES_SECONDS, label: msg`${TEN_MINUTES_SECONDS / ONE_MINUTE_SECONDS} minutes`},
	{value: ONE_HOUR_SECONDS, label: msg`${ONE_UNIT_LABEL} hour`},
	{value: ONE_DAY_SECONDS, label: msg`${ONE_UNIT_LABEL} day`},
	{value: ONE_WEEK_SECONDS, label: msg`${ONE_UNIT_LABEL} week`},
];
export const getTimeoutDurationOptions = (i18n: I18n): ReadonlyArray<TimeoutDurationOption> => {
	return TIMEOUT_DURATION_OPTIONS_DESCRIPTORS.map((opt) => ({
		...opt,
		label: i18n._(opt.label),
	}));
};
